import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "../../constants.js";
import { useBreakpoint, Breakpoint } from "../../hooks/useBreakpoint.js";
import { useHover } from "../../hooks/useHover.js";
import { mergeRefs } from "../../utils/refs.js";
import tileStyles from "./styles.module.scss";
const Title = React__default.forwardRef((props, ref) => {
  const { compact, children, className, htmlMarkup = "span", highlighted } = props;
  const titleClasses = classNames(
    tileStyles["tile__title"],
    {
      [tileStyles["tile__title--highlighted"]]: highlighted,
      [tileStyles["tile__title--compact"]]: compact
    },
    className
  );
  const CustomTag = htmlMarkup;
  return /* @__PURE__ */ jsx(CustomTag, { className: titleClasses, ref, children });
});
Title.displayName = "Title";
const Tile = React__default.forwardRef((props, ref) => {
  const {
    children,
    icon,
    title,
    className = "",
    description,
    fixed = false,
    highlighted = false,
    testId,
    target,
    rel,
    variant = "normal",
    href,
    onClick
  } = props;
  const { hoverRef, isHovered } = useHover();
  const breakpoint = useBreakpoint();
  const mobile = breakpoint < Breakpoint.md;
  const compact = variant === "compact";
  const tileClasses = classNames(
    tileStyles.tile,
    {
      [tileStyles["tile--fixed"]]: fixed,
      [tileStyles["tile--compact"]]: compact,
      [tileStyles["tile--highlighted"]]: highlighted
    },
    className
  );
  const tileTitleWrapperClasses = classNames(tileStyles["title-wrapper"], {
    [tileStyles["title-wrapper--compact"]]: compact
  });
  return /* @__PURE__ */ jsxs(
    "a",
    {
      ref: mergeRefs([ref, hoverRef]),
      href,
      target,
      rel: target === "_blank" ? "noopener noreferrer" : rel,
      className: tileClasses,
      "data-testid": testId,
      "data-analyticsid": AnalyticsId.Tile,
      onClick,
      children: [
        /* @__PURE__ */ jsxs("div", { className: tileTitleWrapperClasses, children: [
          React__default.cloneElement(icon, { size: mobile ? IconSize.Small : IconSize.Medium, isHovered, color: highlighted ? "white" : "black" }),
          React__default.cloneElement(title, { highlighted, compact })
        ] }),
        !compact && !mobile && /* @__PURE__ */ jsx("p", { className: tileStyles.tile__description, children: description }),
        children && /* @__PURE__ */ jsx("div", { className: tileStyles.tile__children, children })
      ]
    }
  );
});
Tile.displayName = "Tile";
Tile.Title = Title;
export {
  Tile,
  Tile as default
};
//# sourceMappingURL=index.js.map
